import React from "react";
import { Container, Txt } from "./Footer.styles";
export var Footer = function () {
    var year = new Date().getFullYear();
    return (React.createElement(Container, null,
        React.createElement(Txt, null,
            "\u00A9 ",
            year,
            " Milestone. All Rights Reserved.")));
};
//# sourceMappingURL=Footer.js.map